import { render, staticRenderFns } from "./PanelWithMetaConfigEditor.vue?vue&type=template&id=bcd39382&lang=pug&"
import script from "./PanelWithMetaConfigEditor.vue?vue&type=script&lang=ts&"
export * from "./PanelWithMetaConfigEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithMetaConfigEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports